import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Navigation from '../components/Navigation';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { CheckCircle, Loader2 } from 'lucide-react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const PaymentSuccess = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get('session_id');
  const [checking, setChecking] = useState(true);
  const [status, setStatus] = useState(null);

  useEffect(() => {
    if (sessionId) {
      checkPaymentStatus();
    }
  }, [sessionId]);

  const checkPaymentStatus = async () => {
    let attempts = 0;
    const maxAttempts = 5;
    const interval = 2000;

    const poll = async () => {
      try {
        const res = await axios.get(`${API}/payments/status/${sessionId}`);
        if (res.data.payment_status === 'paid') {
          setStatus('success');
          setChecking(false);
          return;
        }
        attempts++;
        if (attempts < maxAttempts) {
          setTimeout(poll, interval);
        } else {
          setStatus('pending');
          setChecking(false);
        }
      } catch (error) {
        console.error('Payment check failed', error);
        attempts++;
        if (attempts < maxAttempts) {
          setTimeout(poll, interval);
        } else {
          setStatus('error');
          setChecking(false);
        }
      }
    };

    poll();
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100">
      <Navigation />
      <div className="max-w-2xl mx-auto px-6 py-24">
        <Card>
          <CardHeader className="text-center">
            {checking ? (
              <>
                <Loader2 className="w-16 h-16 mx-auto mb-4 text-secondary animate-spin" />
                <CardTitle className="text-3xl font-heading" data-testid="checking-title">Processing Payment...</CardTitle>
                <CardDescription>Please wait while we confirm your payment</CardDescription>
              </>
            ) : status === 'success' ? (
              <>
                <CheckCircle className="w-16 h-16 mx-auto mb-4 text-secondary" />
                <CardTitle className="text-3xl font-heading text-secondary" data-testid="success-title">Payment Successful!</CardTitle>
                <CardDescription>Your payment has been secured in escrow</CardDescription>
              </>
            ) : (
              <>
                <CardTitle className="text-3xl font-heading" data-testid="pending-title">Payment Processing</CardTitle>
                <CardDescription>Your payment is being processed. Check your contracts for updates.</CardDescription>
              </>
            )}
          </CardHeader>
          <CardContent className="text-center">
            <Button
              onClick={() => navigate('/dashboard')}
              className="bg-primary text-primary-foreground"
              data-testid="dashboard-button"
            >
              Go to Dashboard
            </Button>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default PaymentSuccess;
